/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Fixed URL-template text.
 */
export type PropertySharingTextPart = {
    /**
     * Discriminator for literal text.
     */
    kind: PropertySharingTextPart.kind;
    /**
     * Literal path text or query text using the owning entry's encoding.
     */
    value: string;
};
export namespace PropertySharingTextPart {
    /**
     * Discriminator for literal text.
     */
    export enum kind {
        TEXT = 'text',
    }
}

